<div class="container-tig">
    <div class="title">
        <h4>蒙古文无衬线报体研发过程</h4>
    </div>
    <div class="cont-item">
        <p>蒙古文无衬线报体100%原创，从初期字形设计到字体细节优化调整都是内蒙古社会科学院蒙古语 信息技术研发（MIT）中心的呼斯勒独立创作完成，且不存在抄袭、复制他人作品的情形。本字 体在中国国家版权局进行了版权注册登记，享受版权法保护。
        </p>
    </div>
    <div class="t-yfgc-item">
        <h4>第一步:根据灵感起草手写底稿确定字体风格</h4>
        <p class="title-b"></p>
    </div>
    <div class="yfgc-img">
        <img src="/assets/images/Yfgc/yfgc-1.jpg" alt="Onon字体 - 底稿">
        <img src="/assets/images/Yfgc/yfgc-2.jpg" alt="Onon字体 - 底稿">
        <img src="/assets/images/Yfgc/yfgc-3.jpg" alt="Onon字体 - 底稿">
    </div>
    <div class="t-yfgc-item">
        <h4>第二步:设计字体模板规范</h4>
        <p class="title-b"></p>
    </div>
    <div class="t-yfgc-item">
        <h4>第三步:电脑绘制矢量字体图形</h4>
        <p class="title-b"></p>
    </div>
    <div class="yfgc-img">
        <img src="/assets/images/Yfgc/yfgc-4.jpg" alt="Onon字体 - 电脑绘制矢量字体图形">
    </div>
    <div class="t-yfgc-item">
        <h4>第四步:扩展字符集</h4>
        <p class="title-b"></p>
    </div>
    <div class="t-yfgc-item">
        <h4>第五步:字体版权备案</h4>
        <p class="title-b"></p>
    </div>
    <div class="yfgc-img">
        <img src="/assets/images/Yfgc/yfgc-5.jpg" alt="Onon字体 - 字体版权备案">
    </div>
    <br>
    <br>
</div>